var _g, _path, _g2, _path2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_793_17829)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.2613,
    cy: 13.2613,
    r: 10.2613,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2613 23.5227C18.9285 23.5227 23.5227 18.9285 23.5227 13.2613C23.5227 7.59416 18.9285 3 13.2613 3C7.59415 3 3 7.59416 3 13.2613C3 18.9285 7.59415 23.5227 13.2613 23.5227Z",
    fill: "#EFEAD7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2613 2.99997C12.6091 2.99997 11.9713 3.06153 11.3529 3.17781C16.108 4.07232 19.7058 8.24624 19.7058 13.2612C19.7058 18.2762 16.108 22.4502 11.3529 23.3446C11.9713 23.461 12.6091 23.5225 13.2613 23.5225C18.9285 23.5225 23.5226 18.9284 23.5226 13.2612C23.5226 7.59402 18.9285 2.99997 13.2613 2.99997Z",
    fill: "#E5E0CF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_793_17829",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2613 23.5227C18.9285 23.5227 23.5227 18.9285 23.5227 13.2613C23.5227 7.59416 18.9285 3 13.2613 3C7.59415 3 3 7.59416 3 13.2613C3 18.9285 7.59415 23.5227 13.2613 23.5227Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_793_17829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6365 8.30319C10.5559 8.30319 10.4777 8.31352 10.4023 8.33127C10.8532 8.43722 11.1893 8.84106 11.1893 9.32431C11.1893 9.80746 10.8533 10.2113 10.4023 10.3173C10.4776 10.335 10.5558 10.3454 10.6365 10.3454C11.2005 10.3454 11.6576 9.88832 11.6576 9.3244C11.6576 8.76029 11.2005 8.30319 10.6365 8.30319Z",
    fill: "#DDD8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1893 9.32421C11.1893 8.84106 10.8533 8.43723 10.4024 8.33118C9.95157 8.43713 9.61548 8.84096 9.61548 9.32421C9.61548 9.80736 9.95148 10.2112 10.4024 10.3172C10.8532 10.2113 11.1893 9.80746 11.1893 9.32421Z",
    fill: "#E5E0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5146 20.2799C10.4606 20.2799 10.4084 20.2868 10.3582 20.2986C10.6593 20.3694 10.8839 20.6391 10.8839 20.9619C10.8839 21.2847 10.6594 21.5545 10.3582 21.6252C10.4084 21.6371 10.4606 21.6439 10.5146 21.6439C10.8913 21.6439 11.1967 21.3385 11.1967 20.9618C11.1966 20.5853 10.8913 20.2799 10.5146 20.2799Z",
    fill: "#DDD8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8837 20.962C10.8837 20.6392 10.6592 20.3694 10.358 20.2987C10.0568 20.3695 9.83228 20.6392 9.83228 20.962C9.83228 21.2848 10.0567 21.5546 10.358 21.6253C10.6592 21.5546 10.8837 21.2848 10.8837 20.962Z",
    fill: "#E5E0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82527 16.4319C8.71199 16.4319 8.60237 16.4464 8.4967 16.4713C9.12943 16.62 9.601 17.1867 9.601 17.8649C9.601 18.543 9.12943 19.1098 8.4967 19.2585C8.60237 19.2834 8.71208 19.2979 8.82527 19.2979C9.61663 19.2979 10.2582 18.6564 10.2582 17.8649C10.2581 17.0734 9.61663 16.4319 8.82527 16.4319Z",
    fill: "#DDD8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6008 17.8648C9.6008 17.1868 9.12923 16.62 8.49651 16.4713C7.86379 16.62 7.39221 17.1867 7.39221 17.8648C7.39221 18.5429 7.86379 19.1097 8.49651 19.2584C9.12923 19.1097 9.6008 18.543 9.6008 17.8648Z",
    fill: "#E5E0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76033 8.79861C6.5877 8.79861 6.42057 8.82071 6.25952 8.85854C7.2238 9.08521 7.9425 9.94884 7.9425 10.9823C7.9425 12.0158 7.2238 12.8794 6.25952 13.1061C6.42057 13.1439 6.5877 13.1661 6.76033 13.1661C7.96643 13.1661 8.94412 12.1884 8.94412 10.9823C8.94412 9.77631 7.96643 8.79861 6.76033 8.79861Z",
    fill: "#DDD8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9425 10.9823C7.9425 9.94882 7.2238 9.08519 6.25952 8.85852C5.29524 9.08519 4.57654 9.94882 4.57654 10.9823C4.57654 12.0158 5.29524 12.8794 6.25952 13.1061C7.2238 12.8794 7.9425 12.0158 7.9425 10.9823Z",
    fill: "#E5E0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0679 15.556C16.8545 15.556 16.6478 15.5833 16.4486 15.6302C17.6411 15.9106 18.5299 16.9787 18.5299 18.2566C18.5299 19.5347 17.6411 20.6028 16.4486 20.8832C16.6478 20.93 16.8545 20.9574 17.0679 20.9574C18.5594 20.9574 19.7685 19.7483 19.7685 18.2567C19.7685 16.7651 18.5594 15.556 17.0679 15.556Z",
    fill: "#DDD8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5299 18.2566C18.5299 16.9786 17.6411 15.9104 16.4486 15.6302C15.2561 15.9105 14.3673 16.9786 14.3673 18.2566C14.3673 19.5347 15.2561 20.6028 16.4486 20.8831C17.6411 20.6028 18.5299 19.5347 18.5299 18.2566Z",
    fill: "#E5E0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1523 11.0758C18.0179 11.0758 17.8878 11.093 17.7625 11.1225C18.5131 11.2989 19.0726 11.9713 19.0726 12.7757C19.0726 13.5802 18.5131 14.2525 17.7625 14.429C17.8878 14.4584 18.0179 14.4757 18.1523 14.4757C19.0911 14.4757 19.8523 13.7146 19.8523 12.7757C19.8522 11.8368 19.0911 11.0758 18.1523 11.0758Z",
    fill: "#DDD8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0725 12.7757C19.0725 11.9712 18.513 11.2989 17.7624 11.1224C17.0118 11.2988 16.4523 11.9712 16.4523 12.7757C16.4523 13.5801 17.0118 14.2524 17.7624 14.4289C18.513 14.2525 19.0725 13.5801 19.0725 12.7757Z",
    fill: "#E5E0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.245 13.8354C21.1589 13.8354 21.0756 13.8464 20.9952 13.8653C21.476 13.9783 21.8344 14.4089 21.8344 14.9242C21.8344 15.4395 21.4761 15.8701 20.9952 15.9831C21.0755 16.002 21.1589 16.013 21.245 16.013C21.8463 16.013 22.3337 15.5255 22.3337 14.9242C22.3338 14.3229 21.8463 13.8354 21.245 13.8354Z",
    fill: "#DDD8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8344 14.9241C21.8344 14.4089 21.4761 13.9783 20.9953 13.8652C20.5145 13.9782 20.1561 14.4089 20.1561 14.9241C20.1561 15.4394 20.5144 15.87 20.9953 15.983C21.476 15.87 21.8344 15.4394 21.8344 14.9241Z",
    fill: "#E5E0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.791 9.28372C20.7086 9.28372 20.6289 9.29424 20.552 9.31238C21.0122 9.42055 21.3552 9.83278 21.3552 10.326C21.3552 10.8192 21.0122 11.2314 20.552 11.3396C20.6289 11.3576 20.7086 11.3682 20.791 11.3682C21.3666 11.3682 21.8332 10.9016 21.8332 10.326C21.8332 9.75037 21.3666 9.28372 20.791 9.28372Z",
    fill: "#DDD8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3552 10.326C21.3552 9.83278 21.0122 9.42055 20.552 9.31238C20.0918 9.42055 19.7488 9.83278 19.7488 10.326C19.7488 10.8192 20.0918 11.2314 20.552 11.3396C21.0122 11.2314 21.3552 10.8192 21.3552 10.326Z",
    fill: "#E5E0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66969 5.00223C9.56586 5.00223 9.46541 5.01554 9.36853 5.03832C9.94847 5.17457 10.3807 5.694 10.3807 6.31553C10.3807 6.93706 9.94847 7.4564 9.36853 7.59275C9.46541 7.61552 9.56586 7.62884 9.66969 7.62884C10.395 7.62884 10.983 7.04089 10.983 6.31553C10.983 5.59017 10.395 5.00223 9.66969 5.00223Z",
    fill: "#DDD8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3808 6.31551C10.3808 5.69408 9.94855 5.17465 9.36861 5.0383C8.78877 5.17455 8.35657 5.69399 8.35657 6.31551C8.35657 6.93704 8.78877 7.45638 9.36861 7.59273C9.94855 7.45638 10.3808 6.93695 10.3808 6.31551Z",
    fill: "#E5E0CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_793_17829",
    x: 0.237334,
    y: 0.237334,
    width: 26.048,
    height: 26.048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.38133,
    result: "effect1_foregroundBlur_793_17829"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/Moon.730e127cb50418a16121fd68e7555348.svg";
export { ForwardRef as ReactComponent };